﻿/* eslint-disable */
declare const jQuery: any;
declare const $: any;
interface IXssValidationParams {
    policy: XssPolicy | XssServerPolicy;
    endpoint?: string;
}

interface IXssValidationPayload {
    value: string;
    field: string;
    policy: string;
}

interface XssServerPolicy {
    name: string;
    path: string;
}
enum XssRegexPolicyBehavior {
    match,
    notMatch
}

interface XssPolicyRegularExpression {
    pattern: string;
    options: string;
    behavior: XssRegexPolicyBehavior;   
}

interface XssPolicy {
    name: string;
    allowAnyTag: boolean;
    tags?: XssPolicyHtmlTag[];    
}

interface XssRexexPolicy {
    name: string;
    regularExpressions: XssPolicyRegularExpression[];
}

interface XssPolicyHtmlTag {
    name: string;
    allowAnyAttribute: boolean;
    attributes?: XssPolicyHtmlTagAttribute[];
}

interface XssPolicyHtmlTagAttribute {
    name: string;
    allowAnyValue: boolean;
    allowedValues?: string[];
    allowedPatterns?: XssPolicyRegularExpression[];
}



class XssValidator {

    static isServerPolicy(policy: XssPolicy | XssServerPolicy | XssRexexPolicy): policy is XssServerPolicy {
        return (policy as XssServerPolicy).path !== undefined;
    }
    
    static isClientPolicy(policy: XssPolicy | XssServerPolicy | XssRexexPolicy): policy is XssPolicy {
        return (policy as XssPolicy).tags !== undefined;
    }
    static isRegexPolicy(policy: XssPolicy | XssServerPolicy | XssRexexPolicy): policy is XssRexexPolicy {
        return (policy as XssRexexPolicy).regularExpressions !== undefined;
    }

    public static isValidPolicy(value: string, element: HTMLInputElement, policy: XssPolicy | XssServerPolicy | XssRexexPolicy)     
    {   
        if ( XssValidator.isRegexPolicy(policy)) {
            if (!XssValidator.isValidRegExPolicy(value, element, (policy as XssRexexPolicy).regularExpressions))
                return false;
        }

        if (XssValidator.isClientPolicy(policy)) {
            if (!XssValidator.isValidClientPolicy(value, element, policy as XssPolicy))
                return false;
        }

        if (XssValidator.isServerPolicy(policy)) {
            if (!XssValidator.isValidServerPolicy(value, element, policy as XssServerPolicy))
                return false;
        }

        return true;
    }

    static isValidRegExPolicy(
        value: string,
        element: HTMLInputElement,
        regularExpressions: XssPolicyRegularExpression[]
    ): boolean {

        if (!value || !regularExpressions || regularExpressions.length === 0)
            return true;

        const matchRules = regularExpressions.filter(r => r.behavior === XssRegexPolicyBehavior.match);
        const notMatchRules = regularExpressions.filter(r => r.behavior === XssRegexPolicyBehavior.notMatch);

        // 1️⃣ Blacklist : si une seule règle NotMatch matche → invalide
        for (const rule of notMatchRules) {
            
            const regex = new RegExp(rule.pattern, rule.options);            
            if (regex.test(value))
                return false;
        }

        // 2️⃣ Whitelist : s'il y a des règles Match,
        // au moins une doit matcher
        if (matchRules.length > 0) {
            let anyMatch = false;

            for (const rule of matchRules) {
                const regex = new RegExp(rule.pattern, rule.options);
                if (regex.test(value)) {
                    anyMatch = true;
                    break;
                }
            }

            if (!anyMatch)
                return false;
        }

        return true;
    }

    static isValidServerPolicy(value: string, element: HTMLInputElement, policy: XssServerPolicy): boolean {
        let isValid = true;
        const endPoint = policy.path || "/_xss/validate";
        const payload: IXssValidationPayload = {
            value: value,
            field: element.name,
            policy: policy.name
        };

        $.ajax({
            url: endPoint,
            type: "POST",
            async: false, // requis par jQuery validation
            contentType: "application/json",
            data: JSON.stringify(payload),
            success: function (res) {
                isValid = res.valid === true;
            },
            error: function () {
                isValid = false;
            }
        });
        return isValid;
    }

    static isValidClientPolicy(value: string, element: HTMLInputElement, policy: XssPolicy): boolean {
        return !XssValidator.domContainsXss(value, element, policy);
    }

     
    static domContainsXss(value: string, element: HTMLInputElement, policy: XssPolicy): boolean {

        if (!value || !policy.tags) return false;

        if (policy.allowAnyTag)
            return false;

        var parser = new DOMParser();
        var doc = parser.parseFromString(`<html><body>${value}</body></html>`, "text/html");
        if (!doc.body)
            return false;

        var elements = doc.body.querySelectorAll("*");

        var hasXss = false;

        elements.forEach((docElement) => {
            var tagPolicy = policy.tags?.find(tag => tag.name.toLowerCase() == docElement.tagName.toLowerCase());

            if (!tagPolicy) {
                hasXss = true;
                console.log(`Tag ${docElement.tagName} is not allowed`);
                return;
            }

            if (tagPolicy.allowAnyAttribute) {
                return;
            }

            if (docElement.attributes.length > 0) {
                for (var i = 0; i < docElement.attributes.length; i++) {
                    var att = docElement.attributes[i];

                    var attributePolicy = tagPolicy.attributes?.find(allowedAtt => allowedAtt.name.toLowerCase() == att.name.toLowerCase());
                    if (!attributePolicy) {
                        hasXss = true;
                        console.log(`Attribute ${att.name} is not allowed on tag ${docElement.tagName}`);
                        continue;
                    }

                    if (attributePolicy.allowAnyValue)
                        continue;

                    if ((attributePolicy.allowedValues && attributePolicy.allowedValues.includes(att.value))
                     || (attributePolicy.allowedPatterns && attributePolicy.allowedPatterns.some(p =>
                            p.behavior === 0 ? new RegExp(p.pattern, p.options).test(att.value)
                                             : !new RegExp(p.pattern, p.options).test(att.value))
                       )) continue;

                    hasXss = true;
                    console.log(`Value ${att.value} is not allowed for attribute ${att.name} on tag ${docElement.tagName}`);
                    return;
                }
            }

            return hasXss;
        });
            

        return hasXss;
    }
}

(function ($) {
    

    $.validator.addMethod("xss", function (value: string, element: HTMLInputElement, params: IXssValidationParams) {
        let isValid = true;
        if (!value)
            return isValid;

        isValid = XssValidator.isValidPolicy(value, element, params.policy);       

        return isValid;
    });


    $.validator.unobtrusive.adapters.add(
        "xss",
        ["policy"],
        function (options) {

            const rawPolicy = options.params["policy"];

            let policy: XssPolicy | XssServerPolicy | XssRexexPolicy;

            // JSON sérialisé côté serveur
            if (typeof rawPolicy === "string") {
                policy = JSON.parse(rawPolicy);
            } else {
                policy = rawPolicy;
            }

            options.rules["xss"] = {
                policy: policy
            };

            options.messages["xss"] = options.message;
        }
    );

})(jQuery);